// extracted by mini-css-extract-plugin
export default {"content":"ConfirmModal_content__RL2pR","message":"ConfirmModal_message__pYw42","button-box":"ConfirmModal_button-box__lq9Um"};